// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '@/store/index'

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Полное наименование',
        isSortable: false
      },
      {
        title: 'Краткое наименование',
        isSortable: false
      }
    ]
  },
  forms: [],
  modal: {
    active: false,
    updatedId: null,
    name: '',
    fullName: '',
    validation: {
      short_name: { type: null, message: '' },
      full_name: { type: null, message: '' }
    }
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  isActiveDelete: false
})

const getters = {
  getContractorsFormList: state => state.forms,
  getContractorsFormListTableHeaders: state => state.tableHeaders,
  getContractorsFormListModal: state => state.modal,
  getContractorsFormListSearchValue: state => state.searchValue,
  getContractorsFormListFilter: state => state.filter,
  getContractorsFormListPagination: state => state.pagination,
  getContractorsFormsListIsLoading: state => state.isLoading,
  getContractorsFormListResponseModal: state => state.responseModal,
  getContractorsFormListResponseModalWithTreaties: state => state.responseModalWithTreaties,
  getContractorsFormListActiveDelete: state => state.isActiveDelete
}

const mutations = {
  GET_CONTRACTORS_FORMS: (state, forms) => {
    state.forms = forms.map(form => {
      return {
        ...form,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  TOGGLE_CONTRACTORS_FORMS_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.forms.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  TOGGLE_CONTRACTORS_FORM_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.forms.length
    let counter = 0

    state.forms.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_CONTRACTORS_FORM_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.forms.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  SHOW_CONTRACTORS_FORMS_LIST_MODAL: (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedForm = state.forms.filter(form => {
        return form.id === itemId
      }).pop()

      state.modal.updatedId = itemId
      state.modal.name = selectedForm.short_name
      state.modal.fullName = selectedForm.full_name
    }
  },
  SET_CONTRACTORS_FORM_ITEM_NAME: (state, value) => {
    state.modal.name = value
  },
  SET_CONTRACTORS_FORM_ITEM_FULL_NAME: (state, value) => {
    state.modal.fullName = value
  },
  SET_CONTRACTORS_FORM_ITEM_VALIDATION: (state, valid) => {
    if (valid.short_name) {
      state.modal.validation.short_name.message = valid.short_name[0]
      state.modal.validation.short_name.type = 'error'
    }
    if (valid.full_name) {
      state.modal.validation.full_name.message = valid.full_name[0]
      state.modal.validation.full_name.type = 'error'
    }
  },
  CLEAR_CONTRACTORS_FORMS_MODAL_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'short_name':
        state.modal.validation.short_name = { type: null, message: '' }
        break
      case 'full_name':
        state.modal.validation.full_name = { type: null, message: '' }
        break
      default:
        break
    }
  },
  CLOSE_CONTRACTORS_FORMS_LIST_MODAL: (state) => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.fullName = ''
    state.modal.validation.short_name = { type: null, message: '' }
    state.modal.validation.full_name = { type: null, message: '' }
  },

  // pagination
  SET_CONTRACTORS_FORMS_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  RESET_CONTRACTORS_FORMS_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },

  // search
  SET_CONTRACTORS_FORMS_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  TOGGLE_CONTRACTORS_FORMS_LIST_FILTER: (state) => {
    state.filter.active = !state.filter.active
  },

  // delete checked items
  DELETE_CONTRACTORS_FORM_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили форму(ы)'
    state.responseModal.type = 'main'
  },
  DELETE_CONTRACTORS_FORM_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении формы произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },

  DELETE_CONTRACTORS_FORM_LIST_CHECKED_ITEMS_TREATIES_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.short_name}`
    })
    state.responseModalWithTreaties.isActive = true
    state.responseModalWithTreaties.text = `Данные формы используются в контрагентах:${listNamesErrorItems}`
    state.tableHeaders.allActive = false
  },
  CLOSE_DELETE_CONTRACTORS_FORM_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  CLOSE_DELETE_CONTRACTORS_FORM_LIST_MODAL_WITH_TREATIES: (state) => {
    state.responseModalWithTreaties.isActive = false
    state.responseModalWithTreaties.text = ''
  },
  RESET_CONTRACTORS_FORM_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.forms.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  // reset store
  RESET_CONTRACTORS_FORM_LIST_STORE: (state) => {
    state.searchValue = ''
    state.pagination.currentPage = 1
  }
}

const actions = {
  getContractorsForms ({ commit, state }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const searchFilter = state.searchValue ? `&search[all]=${state.searchValue}` : ''

    axios.get(`${url}/partner-legal-form?expand=partners${searchFilter}&take=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTORS_FORMS', response.data.data)
      commit('SET_CONTRACTORS_FORMS_LIST_PAGINATION', response.headers)
    }).catch(error => {
      console.log('ошибка получения списка контрагентов', error)
    })
  },
  saveContractorsFormItem ({ commit, state, dispatch }) {
    if (!state.modal.updatedId) {
      const createData = {
        short_name: state.modal.name,
        full_name: state.modal.fullName
      }
      axios.post(`${url}/partner-legal-form`, createData, config).then(response => {
        commit('CLOSE_CONTRACTORS_FORMS_LIST_MODAL')
        dispatch('getContractorsForms')
      }).catch(error => {
        console.log('Ошибка обновления договора', error.response)
        commit('SET_CONTRACTORS_FORM_ITEM_VALIDATION', error.response.data.errors)
      })
    } else {
      const updateData = {
        short_name: state.modal.name,
        full_name: state.modal.fullName
      }

      axios.put(`${url}/partner-legal-form/${state.modal.updatedId}`, updateData, config).then(response => {
        commit('CLOSE_CONTRACTORS_FORMS_LIST_MODAL')
        dispatch('getContractorsForms')
      }).catch(error => {
        commit('SET_CONTRACTORS_FORM_ITEM_VALIDATION', error.response.data.errors)
        console.log('Ошибка обновления договора', error.response)
      })
    }
  },
  toggleContractorsFormsListItemControls ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTORS_FORMS_LIST_ITEM_CONTROLS', itemId)
  },
  toggleContractorsFormListItemActive ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTORS_FORM_LIST_ITEM_ACTIVE', itemId)
  },
  toggleContractorsFormListItemActiveAll ({ commit }) {
    commit('TOGGLE_CONTRACTORS_FORM_LIST_ITEM_ACTIVE_ALL')
  },
  showContractorsFormsModal ({ commit }, itemId) {
    commit('SHOW_CONTRACTORS_FORMS_LIST_MODAL', itemId)
  },
  setContractorsFormItemName ({ commit }, value) {
    commit('SET_CONTRACTORS_FORM_ITEM_NAME', value)
  },
  setContractorsFormItemFullName ({ commit }, value) {
    commit('SET_CONTRACTORS_FORM_ITEM_FULL_NAME', value)
  },
  clearContractorsFormsModalValidation ({ commit }, inputName) {
    commit('CLEAR_CONTRACTORS_FORMS_MODAL_VALIDATION', inputName)
  },
  closeContractorsFormsModal ({ commit }) {
    commit('CLOSE_CONTRACTORS_FORMS_LIST_MODAL')
  },
  removeContractorsForm ({ dispatch }, itemId) {
    axios.delete(`${url}/partner-legal-form/${itemId}`, config).then(response => {
      dispatch('getContractorsForms')
    }).catch(error => {
      console.log('Ошибка удаления статуса:' + error)
    })
  },

  // pagination
  getContractorsFormsListPage ({ state, commit }, pageNum) {
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''
    const currentTake = state.pagination.currentTake
    const currentPage = pageNum

    axios.get(`${url}/partner-legal-form?${searchFilter}&orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTORS_FORMS', response.data.data)
      commit('SET_CONTRACTORS_FORMS_LIST_PAGINATION', response.headers)
      commit('CLOSE_CONTRACTORS_LIST_PAGE_LIST')
    })
  },
  resetContractorsFormsListCurrentPage ({ commit }) {
    commit('RESET_CONTRACTORS_FORMS_LIST_CURRENT_PAGE')
  },

  // search
  setContractorsFormListSearchValue ({ commit, dispatch }, searchValue) {
    commit('SET_CONTRACTORS_FORMS_LIST_SEARCH_VALUE', searchValue)
    commit('RESET_CONTRACTORS_FORMS_LIST_CURRENT_PAGE')
    dispatch('getContractorsForms')
  },

  // delete checked items
  deleteContractorsFormListCheckedItems ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    const treatiesItems = []

    state.forms.forEach((e) => {
      if (e.isActive && e.partners === null) {
        checkedItems.push(e)
      } else if (e.isActive && e.partners.length > 0) {
        treatiesItems.push(e)
      }
    })

    if (treatiesItems.length > 0) {
      commit('DELETE_CONTRACTORS_FORM_LIST_CHECKED_ITEMS_TREATIES_ERROR', treatiesItems)
      commit('RESET_CONTRACTORS_FORM_LIST_ALL_CHECKS')

      treatiesItems.forEach((e) => {
        e.isActive = false
      })
    }

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/partner-legal-form/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления формы', error)
        })
      }
    }

    if (checkedItems.length > 0) {
      processMessages(checkedItems).then(() => {
        if (errorItems.length > 0) {
          commit('RESET_CONTRACTORS_FORM_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTORS_FORM_LIST_CHECKED_ITEMS_ERROR', errorItems)
          dispatch('getContractorsForms')
        } else {
          commit('RESET_CONTRACTORS_FORM_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTORS_FORM_LIST_CHECKED_ITEMS_SUCCESS')
          dispatch('getContractorsForms')
        }
      })
    }
  },
  closeContractorsFormListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTORS_FORM_LIST_MODAL')
  },
  closeContractorsFormListDeleteModalWithTreaties ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTORS_FORM_LIST_MODAL_WITH_TREATIES')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
